import { Spinner } from '@/components/Spinner';
import { BannerManagementForm } from './BannerManagementForm';
import { usePromotionalBannerDetail } from './hooks/usePromotionalBannerDetails';

export const BannerManagementFormContainer = ({ promotionId }: { promotionId: string }) => {
  const { promotionalBanner, isLoading } = usePromotionalBannerDetail({ promotionId });

  if (isLoading) return <Spinner />;

  return <BannerManagementForm key={promotionId} promotionalBanner={promotionalBanner} />;
};
